import { DataTypes } from './widgetDataTypes';
import { mapSourceOptionLabels } from '../utils/adNetworks';

const FieldNames = {
    APP: 'app',
    SOURCE: 'source',
    OS: 'os',
    COUNTRY: 'country_field',
};

export const FILTER_CONFIG = [
    {
        key: 'source',
        fieldName: FieldNames.SOURCE,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_SOURCE',
        mixpanelEventName: 'Dashboards - Source Filter Changed',
        mixpanelPropertyName: 'source_names',
        displayName: 'Source',
    },
    {
        key: 'app',
        fieldName: FieldNames.APP,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_APP',
        mixpanelEventName: 'Dashboards - App Filter Changed',
        mixpanelPropertyName: 'app_names',
        displayName: 'App',
    },
    {
        key: 'os',
        fieldName: FieldNames.OS,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_OS',
        mixpanelEventName: 'Dashboards - OS Filter Changed',
        mixpanelPropertyName: 'os_names',
        displayName: 'OS',
    },
    {
        key: 'country_field',
        fieldName: FieldNames.COUNTRY,
        labelKey: 'STATIC.PLACEHOLDERS.SELECT_COUNTRY',
        mixpanelEventName: 'Dashboards - Country Filter Changed',
        mixpanelPropertyName: 'country_names',
        displayName: 'Country',
    },
];

export const createInitialFilterState = (filterConfig = FILTER_CONFIG, defaultValues = {}) => {
    return filterConfig.reduce((acc, config) => {
        acc[config.key] = defaultValues[config.key] || [];
        return acc;
    }, {});
};

export const createGlobalFilters = (filters, filterConfig = FILTER_CONFIG) => {
    const globalFiltersList = [];

    filterConfig.forEach(config => {
        const filterValues = filters[config.key];
        if (filterValues?.length) {
            globalFiltersList.push({
                field: config.key,
                operator: 'in',
                values: filterValues.map(f => f.value),
            });
        }
    });

    return globalFiltersList;
};

export const formatFilterOptions = items => {
    return (
        items?.map(item => ({
            value: item.name,
            label: item.display_name || item.name,
        })) || []
    );
};

export const getFilterOptions = (filterFields, filterConfig = FILTER_CONFIG) => {
    return filterConfig.reduce((options, config) => {
        const filter = filterFields?.find(f => f.name === config.fieldName);
        const filterOptions = filter?.values ? formatFilterOptions(filter.values) : [];
        // Source labels route through the central adnetwork display-name map.
        options[config.key] = config.key === 'source' ? mapSourceOptionLabels(filterOptions) : filterOptions;
        return options;
    }, {});
};

export const FiltersBlacklistToReportType = {
    [DataTypes.SKAN]: [FieldNames.COUNTRY],
    [DataTypes.SKAN_RAW]: [FieldNames.COUNTRY],
    [DataTypes.UNIFIED]: [FieldNames.COUNTRY],
};

export const getBlockedWidgetFilterNames = (dataType, globalFilters) => {
    const filterFields = new Set(globalFilters.map(({ field }) => field));

    const blockedFilterFields = new Set(
        (FiltersBlacklistToReportType[dataType] || []).filter(blockedFilter => filterFields.has(blockedFilter))
    );

    return FILTER_CONFIG.filter(({ fieldName }) => blockedFilterFields.has(fieldName)).map(
        ({ displayName }) => displayName
    );
};
